<div class="detail-modal-body">
  <div class="row display-row">
    <div class="col-12">
      <div class="display-content">
        <div class="display-label">{{ 'sample_sample_nr' | translate }}</div>
        <div class="display-value">
          {{ sample.sampleNr ?? '-' }}
        </div>
      </div>
    </div>
  </div>
  @if (sample.sampleClusterNr) {
    <div class="row display-row">
      <div class="col-6">
        <div class="display-content">
          <div class="display-label">{{ 'sample_cluster_nr' | translate }}</div>
          <div class="display-value">
            {{ sample?.sampleClusterNr }}
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="display-content">
          <div class="display-label">{{ 'sample_cluster_count' | translate }}</div>
          <div class="display-value">
            {{ 'sample_cluster_of' | translate }} {{ sample?.clusterCount ?? '-' }} {{ 'samples' | translate | lowercase }}
          </div>
        </div>
      </div>
    </div>
  }
  <div class="row display-row">
    <div class="col-12">
      <div class="display-content">
        <div class="display-label">{{ 'sample_period' | translate }}</div>
        <div class="display-value">
          {{ sample?.period ?? '-' }}
        </div>
      </div>
    </div>
  </div>
  <div class="row display-row">
    <div class="col-12">
      <div class="display-content">
        <div class="display-label">{{ 'sample_sampler' | translate }}</div>
        <div class="display-value">
          {{ sample?.sampleAuthorityName ?? '-' }}
        </div>
      </div>
    </div>
  </div>
  <div class="row display-row">
    <div class="col-12">
      <div class="display-content">
        <div class="display-label">{{ 'sample_analyse' | translate }}</div>
        <div class="display-value">
          {{ sample?.analysisName ?? '-' }}
        </div>
      </div>
    </div>
  </div>
  <div class="row display-row">
    <div class="col-3">
      <div class="display-content">
        <div class="display-label">{{ 'sample_level' | translate }}</div>
        <div class="display-value">
          {{ sample?.type ?? '-' }}
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="display-content">
        <div class="display-label">{{ 'sample_product_group' | translate }}</div>
        <div class="display-value">
          {{ sample?.productType ?? '-' }}
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="display-content">
        <div class="display-label">{{ 'sample_size' | translate }}</div>
        <div class="display-value">
          {{ sample?.size ?? '-' }}
        </div>
      </div>
    </div>
  </div>
  <div class="row display-row">
    <div class="col-3">
      <div class="display-content">
        <div class="display-label">{{ 'sample_labo' | translate }}</div>
        <div class="display-value">
          {{ sample?.labo ?? '-' }}
        </div>
      </div>
    </div>
    <div class="col-9">
      <div class="display-content">
        <div class="display-label">{{ 'member_purchase_order_detail_lab_reception_date' | translate }}</div>
        <div class="display-value">
          {{ sample?.labReceptionDate | localizedDate: 'dd MMMM yyyy' | display}}
        </div>
      </div>
    </div>
  </div>
</div>
